import React from "react";

export function useLocalStorage<T>(key: string, initialValue?: T): [T, (newValue: T) => void] {

    const [val, setVal] = React.useState<T>(() => {
        const existing = localStorage.getItem(key);

		let result;
		try {
			result = existing ? JSON.parse(existing) : initialValue;
		} catch (e) {
			result = initialValue;
		}

		return result;
    });

    function set(value: T) {
        localStorage.setItem(key, JSON.stringify(value));
        setVal(value);
    }

    return [
        val,
        set
    ];

}